import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import HomePage from './pages/HomePage';
import YatraDetailsPage from './pages/YatraDeatils';
import UpcomingYatra from './pages/UpcomingYatra';
import PastYatra from './pages/PastYatra';
import LoginPage from './pages/Login';
import Footer from './components/Footer';
import DashboardLayout from './pages/dashboard/DashboardLayout';
import YatraList from './pages/dashboard/YatraList';
import YatraPastList from './pages/dashboard/YatraPastList'
import YatraDetails from './pages/dashboard/YatraDetails';
import './index.css';
import WhatsAppButton from './components/WhatsAppButton'

function AppContent() {
  const location = useLocation();

  // Hide header/footer only for exact dashboard layout routes
  const hideHeaderFooter = location.pathname.startsWith('/dashboard');

  return (
    <div className="flex flex-col min-h-screen">
      <main className="flex-grow">
        {!hideHeaderFooter && <Header />}
        <Routes>
          {/* Public site routes */}
          <Route path="/" element={<HomePage />} />
          <Route path="/upcoming" element={<UpcomingYatra />} />
          <Route path="/yatra-details/:id/:yatraSlug" element={<YatraDetailsPage />} />
          <Route path="/past-yatra" element={<PastYatra />} />
          <Route path="/login" element={<LoginPage />} />

          {/* Dashboard layout with nested routes */}
          <Route path="/dashboard" element={<DashboardLayout />}>
            <Route path="yatra-list" element={<YatraList />} />
            <Route path="yatra-past-list" element={<YatraPastList />} />
            <Route path="yatra-list/train-details/:id" element={<YatraDetails />} />
          </Route>
        </Routes>
      </main>
      {!hideHeaderFooter && <Footer />}
       <WhatsAppButton />
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
